import { useEffect, useCallback } from 'react';

import { useRouter, useSearchParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useAuthStore } from '../store/auth.store';

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  return <Container>{children}</Container>;
}

function Container({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.root;

  const { isAuthenticated } = useAuthStore();

  const check = useCallback(() => {
    if (isAuthenticated) {
      router.replace(returnTo);
    }
  }, [isAuthenticated, returnTo, router]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
